import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    field_max_length_25: {
      id: 'field_max_length_25',
      defaultMessage: "Field must be a maximum 25 characters length",
      description: '',
    },
    field_max_length_40: {
      id: 'field_max_length_40',
      defaultMessage: "Field must be a maximum 40 characters length",
      description: '',
    },
    field_min_length_8: {
      id: 'field_min_length_8',
      defaultMessage: "Field must be a minimum 8 characters length",
      description: '',
    },
    field_must_be_an_email: {
      id: 'field_must_be_an_email',
      defaultMessage: "Field has to be an email",
      description: '',
    },
    email_placeholder_register_text: {
      id: 'email_placeholder_register_text',
      defaultMessage: "Enter a valid email address",
      description: '',
    },
    recovery_email_sent_info_text: {
      id: 'recovery_email_sent_info_text',
      defaultMessage: "If user with email exist, message has been sent to you with password reset details",
      description: '',
    },
    forgot_button_forgot_text: {
      id: 'forgot_button_forgot_text',
      defaultMessage: "Get back password",
      description: '',
    },
    forgot_submit_button_text: {
      id: 'forgot_submit_button_text',
      defaultMessage: "Reset",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/ForgotForm/Messages.js